import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth"; 

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return null; 
  return user ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
